import { ImgID } from "../image_loader/img_id.js";

export class AvatarUtils {
  // Default avatar id (the server's default for every new player): the player's
  // Telegram photo, or their initials on a gradient when there is no photo.
  // Drawn by UIAvatarSelectionItem; getAvatarImgId returns only a placeholder.
  public static readonly TELEGRAM_AVATAR_ID = 0;

  // Reserved avatar id meaning "use the player's Facebook photo".
  // The real photo is loaded by URL (see facebook_avatar_loader); getAvatarImgId
  // returns a placeholder ImgID used until/if the remote photo is available.
  public static readonly FACEBOOK_AVATAR_ID = 987;

  // Avatar_0 moved off id 0 when that id became the Telegram avatar.
  private static readonly AVATAR_0_ID = 7;

  // Picture avatars in the order the selection grid shows them.
  public static readonly PICTURE_AVATAR_IDS: readonly number[] = [ 7, 1, 2, 3, 4, 5, 6, 8, 9 ];

  public static isTelegramAvatar( avatar_id: number ): boolean
  {
    return avatar_id === AvatarUtils.TELEGRAM_AVATAR_ID;
  }

  // Picture avatars already have their round frame painted into the image.
  public static hasBakedFrame( avatar_id: number ): boolean
  {
    return avatar_id !== AvatarUtils.TELEGRAM_AVATAR_ID && avatar_id !== AvatarUtils.FACEBOOK_AVATAR_ID;
  }

  public static getAvatarImgId( avatar_id: number ): ImgID
  {
    if ( avatar_id === AvatarUtils.FACEBOOK_AVATAR_ID )
      return ImgID.FacebookIcon;

    if ( avatar_id === AvatarUtils.AVATAR_0_ID )
      return ImgID.Avatar_0;

    const ids = [
      ImgID.Avatar_0,  ImgID.Avatar_1,  ImgID.Avatar_2,  ImgID.Avatar_3,  ImgID.Avatar_4,
      ImgID.Avatar_5,  ImgID.Avatar_6,  ImgID.Avatar_7,  ImgID.Avatar_8
    ];

    if ( avatar_id >= 0 && avatar_id < ids.length )
      return ids[avatar_id];

    return ImgID.Avatar_0;
  }
}
